<template>
  <!-- <transition name="modal" appear> -->
  <div class="modal modal-overlay" @click.self="$emit('close')">
    <div class="maincont" id="Data_download">
      <div id="download">
        <!-- <div class="ef--inner"> -->
          <div id="download_set">
            <h2>{{ title }}</h2>
            <dl class="display_date">
              <select id="hyouji-graph" name="hyouji-graph" style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;" v-model="electricDataType" v-if="type == 'demandfile'">
                <option value="1">デマンドデータ[kW]</option>
                <option value="2">使用電力量[kWh]</option>
              </select>
              <br><br><br>
              <dt>取得開始</dt>
              <dd>
                <datetime
                  value-zone="local"
                  style="display:inline-block;"
                  input-style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                  v-model="getStartDate"
                  format="yyyy年MM月dd日"
                  type="date"
                  v-bind:min-datetime="minDateS"
                  v-bind:max-datetime="maxDateS"
                  v-if="type != 'demandfile' || (type == 'demandfile' && electricDataType != 2)"
                ></datetime>
                <datepicker
                  :minimum-view="'month'"
                  format="yyyy年MM月"
                  :language="ja"
                  :disabled-dates="disabledDatesS"
                  style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                  v-model="getStartMonth"
                  v-if="type == 'demandfile' && electricDataType == 2"
                ></datepicker>

                <!-- <select v-model="getStartDate" id="dl_start">
                  <option
                    v-for="(option, index) in dateOptions"
                    v-bind:value="option.value"
                    v-bind:key="index"
                  >{{ option.text }}</option>
                </select>-->
              </dd>
              <span>~</span>

              <dt>取得終了</dt>
              <dd>
                <datetime
                  value-zone="local"
                  style="display:inline-block;"
                  input-style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                  v-model="getEndDate"
                  format="yyyy年MM月dd日"
                  type="date"
                  v-bind:min-datetime="minDateE"
                  v-bind:max-datetime="maxDateE"
                  v-if="type != 'demandfile' || (type == 'demandfile' && electricDataType != 2)"
                ></datetime>
                <datepicker
                  :minimum-view="'month'"
                  format="yyyy年MM月"
                  :language="ja"
                  :disabled-dates="disabledDatesE"
                  style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                  v-model="getEndMonth"
                  v-if="type == 'demandfile' && electricDataType == 2"
                ></datepicker>

                <!-- <select v-model="getEndDate" id="dl_end">
                  <option
                    v-for="(option, index) in dateOptions"
                    v-bind:value="option.value"
                    v-bind:key="index"
                  >{{ option.text }}</option>
                </select>-->
              </dd>
            </dl>
            <div id="submit_area">
              <input type="button" id="submit" class="submit" value="帳票ダウンロード" @click="onDownload">
            </div>
          </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import moment from "moment-timezone";
import Datepicker from "vuejs-datepicker";
import {ja} from 'vuejs-datepicker/dist/locale'
// require("moment-timezone")

moment.tz.setDefault("Asia/Tokyo");
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "download-dialog",
  props: ["account", "type"],
  components: {
    Datepicker
  },
  data: function() {
    return {
      dateOptions: [],
      startDate: "",
      endDate: "",
      title: "",
      maxDateS: "",
      minDateS: "",
      maxDateE: "",
      minDateE: "",
      electricDataType: 1,
      ja:ja,
      startMonth: "",
      endMonth: "",
      disabledDatesS: [],
      disabledDatesE: [],
      maxMonthS: "",
      minMonthS: "",
      maxMonthE: "",
      minMonthE: "",
    };
  },
  watch: {
    electricDataType: function(newValue, oldValue) {
      console.log("electricDataType");
      console.log(newValue);
      if (newValue == 2) {
        this.minDateS = moment
          .utc(this.endDate, "YYYY/MM/DD")
          .add(-3, "year")
          .toISOString();
      } else {
        this.minDateS = moment
          .utc(this.endDate, "YYYY/MM/DD")
          .add(-1, "year")
          .toISOString();
      }
    }
  },
  computed: {
    getStartDate: {
      get: function() {
        const m = moment.utc(this.startDate, "YYYY/MM/DD").toISOString();
        return m;
      },
      // setter 関数
      set: function(newValue) {
        newValue = moment(newValue).format("YYYY/MM/DD");
        
        this.startDate = "";
        

        this.startDate = newValue;
        this.minDateE = moment
          .utc(this.startDate, "YYYY/MM/DD")
          // .add(1, "days")
          .toISOString();
        // this.getRealtime(this.startDate, this.endDate);

        // 取得開始日時は最大1年間選択可
        this.maxDateE = moment
          .utc(this.startDate, "YYYY/MM/DD")
          .add(1, "years")
          .toISOString();

        const tmpNewValue = moment
          .utc(newValue, "YYYY/MM/DD")
          .toISOString();
        const tmpStartDate = moment
          .utc(newValue, "YYYY/MM/DD")
          .add(1, "years")
          .toISOString();
        const tmpEndDate = moment
          .utc(this.endDate, "YYYY/MM/DD")
          .toISOString();

        // 取得開始日時より1年以降の取得終了日時が選択されていた場合は、取得開始日時から1年後を取得終了日時とする
        if (tmpEndDate > tmpStartDate) {
          this.endDate = moment(tmpStartDate).format("YYYY/MM/DD");
        } else if (tmpEndDate < tmpNewValue) { // 取得開始日時 > 取得終了日時の場合は、取得終了日時を合わせる
          this.endDate = newValue;
        }
      }
    },
    getEndDate: {
      get: function() {
        const m = moment.utc(this.endDate, "YYYY/MM/DD").toISOString();
        return m;
      },
      // setter 関数
      set: function(newValue) {
        newValue = moment(newValue).format("YYYY/MM/DD");
        this.endDate = "";
        
        this.endDate = newValue;
      }
    },
    getStartMonth: {
      get: function() {
        const m = moment.utc(this.startMonth, "YYYY/MM/DD").toISOString();
        return m;
      },
      set: function(newValue) {
        this.startMonth = moment(newValue).format("YYYY/MM/DD");
        const momentMinMonthE = moment
          .utc(this.startMonth, "YYYY/MM/DD");
        this.minMonthE = new Date(momentMinMonthE.get('year'), momentMinMonthE.get('month'), 1);
        this.disabledDatesE = {
          to: this.minMonthE,
          from: this.maxMonthE
        };
      }
    },
    getEndMonth: {
      get: function() {
        const m = moment.utc(this.endMonth, "YYYY/MM/DD").toISOString();
        return m;
      },
      set: function(newValue) {
        this.endMonth = moment(newValue).format("YYYY/MM/DD");
        const momentMaxMonthS = moment
          .utc(this.endMonth, "YYYY/MM/DD");
        this.maxMonthS = new Date(momentMaxMonthS.get('year'), momentMaxMonthS.get('month'), 1);
        this.disabledDatesS = {
          to: this.minMonthS,
          from: this.maxMonthS
        };
      }
    },
  },
  mounted: function() {
    console.log("DownloadDialog:mounted");

    this.startDate = moment()
      // .add(-1, "days")
      .format("YYYY/MM/DD");
    this.endDate = moment().format("YYYY/MM/DD");
    this.dateOptions = this.getMonitoringDateOptions();

    this.minDateS = moment
      .utc(this.endDate, "YYYY/MM/DD")
      .add(-5, "year")
      .toISOString();
    this.maxDateS = moment
      .utc(this.endDate, "YYYY/MM/DD")
      // .add(-1, "days")
      .toISOString();
    this.minDateE = moment
      .utc(this.startDate, "YYYY/MM/DD")
      // .add(1, "days")
      .toISOString();
    this.maxDateE = moment
      .utc(this.endDate, "YYYY/MM/DD")
      .add(7, "days")
      .toISOString();

    this.startMonth = moment().format("YYYY/MM/DD");
    this.endMonth = moment().format("YYYY/MM/DD");
    const momentMinMonthS = moment
      .utc(this.endMonth, "YYYY/MM/DD")
      .add(-5, "year");
    const momentMaxMonthS = moment
      .utc(this.endMonth, "YYYY/MM/DD");
    const momentMinMonthE = moment
      .utc(this.startMonth, "YYYY/MM/DD");
    const momentMaxMonthE = moment
      .utc(this.endMonth, "YYYY/MM/DD");

    this.minMonthS = new Date(momentMinMonthS.get('year'), momentMinMonthS.get('month'), 1);
    this.maxMonthS = new Date(momentMaxMonthS.get('year'), momentMaxMonthS.get('month'), 1);
    this.minMonthE = new Date(momentMinMonthE.get('year'), momentMinMonthE.get('month'), 1);
    this.maxMonthE = new Date(momentMaxMonthE.get('year'), momentMaxMonthE.get('month'), 1);

    this.disabledDatesS = {
      to: this.minMonthS,
      from: this.maxMonthS
    };
    this.disabledDatesE = {
      to: this.minMonthE,
      from: this.maxMonthE
    };

    console.log(`type= %o`,this.type);
    if (this.type == "weatherfile") {
      this.title = "気象データ";
    } else if (this.type == "temperaturefile") {
      this.title = "気温データ";
    } else {
      this.title = "電力データ";
    }
  },
  methods: {
    onCancel: function() {
      console.log("onCancel");

      this.$emit("close");
    },
    onChange: function() {
      console.log("onChange");
      this.$validator.validateAll().then(result => {
        // console.log(result);

        if (result) {
          this.changePassword(
            this.account,
            this.current_password,
            this.new_password
          );
        }
      });
    },
    onDownload: function() {
      this.downloadFile(this.startDate, this.endDate, this.type);
    },
    downloadFile: function(startDate, endDate, type) {
      console.log("downloadFile");
      const self = this;

      const startDateStr = startDate;
      const endDateStr = endDate;

      let param = {
        start_date: startDateStr,
        end_date: endDateStr
      };

      console.log(`param= %o`,param);

      let url = `/srv/api/${type}/${this.account}`;
      if (this.type == "demandfile" && this.electricDataType == 2) {
        url = `/srv/api/electric_power_file/${this.account}`;
        param = {
          start_date: this.startMonth,
          end_date: this.endMonth
        };
      }
      console.log(`url= %o`,url);

      this.$axios
        .post(url, param, {
          withCredentials: true,
          responseType: "blob",
          exposedHeaders: ["Content-Disposition"]
        })
        .then(response => {
          console.log(response);
          console.log(response.headers["content-disposition"]);
          let fileName = "";
          const contentDisposition = response.headers["content-disposition"];
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, "");
          }
          console.log(fileName);

          if (
            response.headers["content-type"].indexOf("application/json") != -1
          ) {
            alert("ダウンロードできませんでした");
            return;
          }
          const dl = document.getElementById("downloadLink");
          if (dl != undefined) dl.parentNode.removeChild(dl);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("id", "downloadLink");
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.$emit("close");
        })
        .catch(error => {
          // ...
          console.log(error);
        });
    }
  }
};
</script>

<style>
.modal.modal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal .modal-window {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.modal .modal-content {
  padding: 10px 20px;
}

.modal .modal-footer {
  background: #ccc;
  padding: 10px;
  text-align: right;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;

  /* .modal-window {
   transition: opacity 0.4s, transform 0.4s;
 } */
}

.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  /* .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  } */
}
</style>